// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1N4D5","rows":"style_rows__3DCcz","row":"style_row__3bnHo","embeddedForms":"style_embeddedForms__2RzN9"};